import Button from "../../base/Button";

const renderIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="26"
        viewBox="0 0 25 26"
    >
        <g fill="none" fillRule="evenodd" stroke="#FFF">
            <path d="M5.052 13h19.034" />
            <path
                strokeLinecap="square"
                d="M16.638 5.552L24.086 13l-7.448 7.448M.914 1.414v23.172"
            />
        </g>
    </svg>
);

/**
 * Toolbar button for moving selected lights to the right.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered move right button.
 */
const MoveRightButton = (props) => (
    <Button {...props} renderIcon={renderIcon} />
);

export default MoveRightButton;
